import canadaStatesData from './candaStates.json'
import canadaCitiesData from './canadaCities.json'

export const CANADA_STATES = canadaStatesData.states.map((oneState)=>({label:oneState.name, value: oneState.name}));

export const CANADA_CITIES = (state_code) => {
    return canadaCitiesData.states.filter((item)=>(item.name === state_code))[0]?.cities.map((city)=>({label:city.name, value: city.name})) || [];
}

